import React from "react";

const BraintreeStateContext = React.createContext(null);

export default BraintreeStateContext;
